export const LICENCE_CATEGORY = 'licence-category';
export const BASED_LAND_FIXED_STATION_INFORMATION = 'based-land-fixed-station-information';
export const ADDRESS = 'address';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const VENDOR_INFORMATION = 'vendor-information';
export const VENDOR_ADDRESS = 'vendor-address';
export const RADIO_EQUIPMENT_INFORMATION = 'radio-equipment-information';
export const ANTENNA_INFORMATION = 'antenna-information';
export const ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION = 'antenna-displacement-from-station-location';
export const FILTER_INFORMATION = 'filter-information';
export const FEEDER_INFORMATION = 'feeder-information';
export const FREQUENCY_AND_EMISSION_CLASS_INFORMATION = 'frequency-and-emission-class-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const PMN_APPLICATION = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: '',
        fieldList: [
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            },
            {
                id: 'proposed-use-of-system-equipment',
                label: 'Proposed use of System/Equipment',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks-optional',
                label: 'Remarks (Optional)',
                type: 'text',
                span: 12
            },
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'select'
            }
        ]
    },
    {
        sectionID: BASED_LAND_FIXED_STATION_INFORMATION,
        sectionName: 'Base/Land Fixed Station Information',
        fieldList: [
            {
                id: 'call-sign-optional',
                label: 'Call Sign (Optional)',
                type: 'text'
            },
            {
                id: 'location-of-station',
                label: 'Location Of Station (e.g. Rooftop)',
                type: 'text'
            },
            {
                id: 'station-name',
                label: 'Station Name',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ADDRESS,
        sectionName: 'Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text'
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LATITUDE,
        sectionName: 'Latitude',
        fieldList: [
            {
                id: 'latitude-degrees',
                label: 'Latitude Degrees',
                type: 'dropdown',
                apiID: 'CommonData',
                category: 'CommonData'
            },
            {
                id: 'latitude-minutes',
                label: 'Latitude Minutes',
                type: 'text'
            },
            {
                id: 'latitude-seconds',
                label: 'Latitude Seconds',
                type: 'text'
            }
        ]
    },
    {
        sectionID: LONGITUDE,
        sectionName: 'Longitude',
        fieldList: [
            {
                id: 'longitude-degrees',
                label: 'Longitude Degrees',
                type: 'text'
            },
            {
                id: 'longitude-minutes',
                label: 'Longitude Minutes',
                type: 'text'
            },
            {
                id: 'longitude-seconds',
                label: 'Longitude Seconds',
                type: 'text'
            },
            {
                id: 'building-height-m',
                label: 'Building Height (m)',
                type: 'text'
            },
            {
                id: 'antenna-effective-height-m',
                label: 'Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'radius-of-operation',
                label: 'Radius Of Operation (km)',
                type: 'text'
            },
            {
                id: 'antenna-elevation-angle',
                label: 'Antenna Elevation Angle- with reference to horizontal plane (degree)',
                type: 'text'
            },
            {
                id: 'transportable-optional',
                label: 'Transportable? (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_INFORMATION,
        sectionName: 'Vendor Information (if applicable)',
        fieldList: [
            {
                id: 'vendor-name-optional',
                label: 'Vendor Name (Optional)',
                type: 'text'
            },
            {
                id: 'vendor-licence-number-optional',
                label: 'Vendor Licence Number (Optional)',
                type: 'text'
            },
            {
                id: 'contact-person-optional',
                label: 'Contact Person (Optional)',
                type: 'text'
            },
            {
                id: 'contact-number-optional',
                label: 'Contact Number (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: VENDOR_ADDRESS,
        sectionName: 'Address',
        fieldList: [
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text'
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: RADIO_EQUIPMENT_INFORMATION,
        sectionName: 'Radio Equipment Information',
        fieldList: [
            {
                id: 'manufacturer-transmitter',
                label: 'Manufacturer (Transmitter)',
                type: 'text'
            },
            {
                id: 'manufacturer-receiver',
                label: 'Manufacturer (Receiver)',
                type: 'text'
            },
            {
                id: 'model-transmitter',
                label: 'Model (Transmitter)',
                type: 'text'
            },
            {
                id: 'model-receiver',
                label: 'Model (Receiver)',
                type: 'text'
            },
            {
                id: 'output-power',
                label: 'Output Power (W) (Transmitter)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ANTENNA_INFORMATION,
        sectionName: 'Antenna Information',
        fieldList: [
            {
                id: 'manufacturer',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'polarization',
                label: 'Polarization',
                type: 'text'
            },
            {
                id: 'antenna-effective-height-m-2',
                label: 'Antenna Effective Height (m) (above ground level)',
                type: 'text'
            },
            {
                id: 'antenna-elevation-angle-2',
                label: 'Antenna Elevation Angle- with reference to horizontal plane (degree)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: ANTENNA_DISPLACEMENT_FROM_STATION_LOCATION,
        sectionName: 'Antenna Displacement from station location',
        fieldList: [
            {
                id: 'north-latitude-displacement',
                label: 'North Latitude Displacement',
                type: 'text'
            },
            {
                id: 'east-longitude-displacement',
                label: 'East Longitude Displacement',
                type: 'text'
            },
            {
                id: 'gain-db',
                label: 'Gain (dB)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FILTER_INFORMATION,
        sectionName: 'Filter Information',
        fieldList: [
            {
                id: 'manufacturer-2',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'model',
                label: 'Model',
                type: 'text'
            },
            {
                id: 'insertion-loss-db',
                label: 'Insertion Loss (dB)',
                type: 'text'
            },
            {
                id: 'tuned-frequency',
                label: 'Tuned Frequency (MHz)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FEEDER_INFORMATION,
        sectionName: 'Feeder Information',
        fieldList: [
            {
                id: 'feeder-line-type-transmit',
                label: 'Feeder Line Type (Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-type-receive',
                label: 'Feeder Line Type (Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-m-transmit',
                label: 'Feeder Line Length(M)(Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-length-m-receive',
                label: 'Feeder Line Length(M)(Receive)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-db-transmit',
                label: 'Feeder Line Loss(dB)(Transmit)',
                type: 'text'
            },
            {
                id: 'feeder-line-loss-db-receive',
                label: 'Feeder Line Loss(dB)(Receive)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FREQUENCY_AND_EMISSION_CLASS_INFORMATION,
        sectionName: 'Frequency and Emission Class Information',
        fieldList: [
            {
                id: 'frequency-and-emission-class-information-list',
                label: '',
                type: 'tableAccordion',
                span: 12,
                subFields: [
                    {
                        id: 'frequency-and-emission-class-info-table',
                        label: '',
                        type: 'table',
                        subFields: [
                            {
                                id: 'id-no',
                                header: 'S/N',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-tx',
                                header: 'Desired Frequency (MHz) - From (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-tx',
                                header: 'Desired Frequency (MHz) - To (Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-from-rx',
                                header: 'Desired Frequency (MHz) - From (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-frequency-mhz-to-rx',
                                header: 'Desired Frequency (MHz) - To (Rx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-tx',
                                header: 'Bandwidth (kHz)(Tx)',
                                type: 'text'
                            },
                            {
                                id: 'desired-bandwidth-khz-rx',
                                header: 'Bandwidth (kHz)(Rx)',
                                type: 'text'
                            },
                            {
                                id: 'start-time',
                                header: 'Start Time',
                                type: 'text'
                            },
                            {
                                id: 'stop-time',
                                header: 'Stop Time',
                                type: 'text'
                            }
                        ]
                    },
                    {
                        id: 'frequency-and-emission-class-info-accordion',
                        label: '',
                        type: 'accordion',
                        subFields: [
                            {
                                id: 'emission-class-transmit',
                                label: 'Emission Class - Transmit',
                                type: 'text'
                            },
                            {
                                id: 'emission-class-receive',
                                label: 'Emission Class - Receive',
                                type: 'text'
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
